import axios from 'axios';
import { AppConfig, JWT } from '../config';

// IMP-210: CompanyAction.GetParents 의 순수 데이터 조회 로직 추출.
// action↔action 의존(SmartDentAction/LicenseAction → CompanyAction) 제거 목적.
// dispatch/Redux store 미의존. localStorage user.companyId 기반 부모 회사 계층 조회.
export const getParents = async () => {
    try {
        const companyId = JSON.parse(localStorage.getItem('user')).companyId;
        const ret = await axios.get(AppConfig.API_SERVER_PATH + '/company/getparents/' + companyId, JWT());
        return ret.data.status === 'success' ? ret.data.data : [];
    } catch (error) {
        console.error('companyHierarchyService.getParents error:', error);
        return [];
    }
};

// BUG-172: RayData operator(회사) 셀렉트 조직 계층 권한 스코프 SSoT.
// 접근 가능 회사 집합 = clist(login 발급, config JWT() 의 x-ray-clist 헤더 값과 동일,
// BE companyId $in 필터 근거). CalendarAction.js 의 clist.split(',') 패턴과 정합.
// BUG-173 정정: HQ 전체노출은 "clist 가 전체 트리를 열거한다"는 가정으로 보장되지 않는다
// (clist 열거가 전체 트리를 담지 못하는 환경이 실존). 실제로는 scopeCompaniesForUser 의
// isHqUser bypass 로 보장한다. 본 파일(clist 필터)은 FE 표시(UX) 스코프일 뿐이며, 실제
// 쓰기 권한 경계는 BE `assertCompanyWriteScope`(서버 세션 writeScope) 가 담당한다.
export const parseClist = (clist) => {
    // 리터럴 문자열 "undefined"/"null"(BE 가 clist 누락 시 localStorage 에 저장되는 함정) 제거.
    const clean = (s) => {
        const v = String(s).trim();
        return v && v !== 'undefined' && v !== 'null' ? v : null;
    };
    if (Array.isArray(clist)) return clist.map(clean).filter(Boolean);
    if (typeof clist === 'string') return clist.split(',').map(clean).filter(Boolean);
    return [];
};

// companyList 를 접근 가능 clist 로 필터링. clist 부재/빈값이면 fail-closed(본인 회사만)
// + console.warn(§7 no-silent-drop — silent 차단 금지).
export const filterCompaniesByClist = (companyList, clist, fallbackCompanyId) => {
    const list = Array.isArray(companyList) ? companyList : [];
    const ids = parseClist(clist);
    if (ids.length === 0) {
        console.warn('[guard] filterCompaniesByClist: empty clist — fail-closed to own company', {
            handler: 'RayDataAddUpdate.setCompanySelect',
            callerCompanyId: fallbackCompanyId,
            reason: 'clist missing/empty; least-privilege scope',
        });
        return fallbackCompanyId ? list.filter((c) => c?.companyId === fallbackCompanyId) : [];
    }
    const idSet = new Set(ids);
    return list.filter((c) => idSet.has(c?.companyId));
};

// BUG-173 / PR #460 리뷰 Major#2: HQ 전체노출 예외 + 비-HQ clist 스코프 위임을 하나의
// SSoT 로 통합. isHqUser 는 호출측(컴포넌트)이 이미 계산해 내려주는 값을 그대로 받는다
// (헬퍼 내부에서 UserType 재계산 없음). FE 표시(UX)용 스코프 — 실제 쓰기 권한 경계는
// BE `assertCompanyWriteScope`(서버 세션 writeScope).
export const scopeCompaniesForUser = (companyList, clist, isHqUser, fallbackCompanyId) => {
    if (isHqUser === true) return Array.isArray(companyList) ? companyList : [];
    return filterCompaniesByClist(companyList, clist, fallbackCompanyId);
};
